"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _uiTheme = require("@kyruus/ui-theme");
const ButtonComponent = (0, _uiTheme.withMuiThemeAdapter)(_Button.default);

// !important is needed for margin-top because otherwise this style gets overridden by material-ui styles
const StyledButtonComponent = /*#__PURE__*/(0, _base.default)(ButtonComponent, process.env.NODE_ENV === "production" ? {
  target: "errnoga0"
} : {
  target: "errnoga0",
  label: "StyledButtonComponent"
})("margin-top:", (0, _uiTheme.fromTheme)('spacing_xlarge'), "!important;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Button_ = props => /*#__PURE__*/_react.default.createElement(StyledButtonComponent, props);
Button_.displayName = 'Button';
// PropTypes taken from material-ui.
Button_.propTypes = {
  /**
   * The content of the button.
   */
  children: _propTypes.default.node.isRequired,
  /**
   * @ignore
   */
  className: _propTypes.default.string,
  /**
   * The color of the component. It's using the theme palette when that makes sense.
   */
  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'accent', 'contrast']),
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   * The default value is a `button`.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  /**
   * Uses a smaller minWidth, ideal for things like card actions.
   */
  dense: _propTypes.default.bool,
  /**
   * If `true`, the button will be disabled.
   */
  disabled: _propTypes.default.bool,
  /**
   * If `true`, the  keyboard focus ripple will be disabled.
   * `disableRipple` must also be true.
   */
  disableFocusRipple: _propTypes.default.bool,
  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes.default.bool,
  /**
   * If `true`, will use floating action button styling.
   */
  fab: _propTypes.default.bool,
  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: _propTypes.default.string,
  /**
   * If `true`, and `fab` is `true`, will use mini floating action button styling.
   */
  mini: _propTypes.default.bool,
  /**
   * If `true`, the button will use raised styling.
   */
  raised: _propTypes.default.bool,
  /**
   * @ignore
   */
  type: _propTypes.default.string
};
var _default = exports.default = Button_;
Button_.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Button",
  "props": {
    "children": {
      "description": "The content of the button.",
      "type": {
        "name": "node"
      },
      "required": true
    },
    "className": {
      "description": "@ignore",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "color": {
      "description": "The color of the component. It's using the theme palette when that makes sense.",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'default'",
          "computed": false
        }, {
          "value": "'inherit'",
          "computed": false
        }, {
          "value": "'primary'",
          "computed": false
        }, {
          "value": "'accent'",
          "computed": false
        }, {
          "value": "'contrast'",
          "computed": false
        }]
      },
      "required": false
    },
    "component": {
      "description": "The component used for the root node.\nEither a string to use a DOM element or a component.\nThe default value is a `button`.",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "func"
        }]
      },
      "required": false
    },
    "dense": {
      "description": "Uses a smaller minWidth, ideal for things like card actions.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "disabled": {
      "description": "If `true`, the button will be disabled.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "disableFocusRipple": {
      "description": "If `true`, the  keyboard focus ripple will be disabled.\n`disableRipple` must also be true.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "disableRipple": {
      "description": "If `true`, the ripple effect will be disabled.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "fab": {
      "description": "If `true`, will use floating action button styling.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "href": {
      "description": "The URL to link to when the button is clicked.\nIf defined, an `a` element will be used as the root node.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "mini": {
      "description": "If `true`, and `fab` is `true`, will use mini floating action button styling.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "raised": {
      "description": "If `true`, the button will use raised styling.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "type": {
      "description": "@ignore",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};